import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePricing } from '@/contexts/PricingContext';
import { Skeleton } from '@/components/ui/skeleton';

export const PricingCards = () => {
  const { loading, pricing } = usePricing();

  const PriceDisplay = ({ plan, testid }) => (
    <div data-testid={testid} className="text-[28px] font-semibold text-slate-900 tracking-tight">
      {loading ? (
        <Skeleton data-testid="geo-price-skeleton" className="h-8 w-24" />
      ) : (
        <span data-testid="geo-price-ready">{pricing[plan].display.split('/')[0]}</span>
      )}
    </div>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {/* Single Story */}
      <div data-testid="pricing-plan-single" className="bg-white border border-slate-200 rounded-tlLg p-6 shadow-tl-soft flex flex-col">
        <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500">Single story</div>
        <div className="mt-3 flex items-baseline gap-2">
          <PriceDisplay plan="single" testid="pricing-single-amount" />
          <span className="text-[12px] text-slate-500">one time</span>
        </div>
        <ul className="mt-5 space-y-2 text-[13px] text-slate-600 flex-1">
          <li>✓ 1 personalized mythology story</li>
          <li>✓ Any mythology tradition</li>
          <li>✓ PDF download</li>
        </ul>
        <a href="/create" data-testid="pricing-single-cta" className="mt-6 block">
          <Button variant="outline" className="w-full h-11 border-tl-purple text-tl-purple hover:bg-tl-purpleLight">Get one story</Button>
        </a>
      </div>

      {/* Family Plan */}
      <div data-testid="pricing-plan-family" className="bg-white border-[1.5px] border-tl-purple rounded-tlLg p-6 shadow-tl-soft flex flex-col relative">
        <div className="absolute -top-3 left-6 bg-tl-gold text-[10px] uppercase tracking-[0.14em] text-[#1a1625] px-2 py-1 rounded-full font-semibold">Most popular</div>
        <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500">Family plan</div>
        <div className="mt-3 flex items-baseline gap-2">
          <PriceDisplay plan="family" testid="pricing-family-amount" />
          <span className="text-[12px] text-slate-500">per month</span>
        </div>
        <ul className="mt-5 space-y-2 text-[13px] text-slate-600 flex-1">
          <li>✓ Unlimited stories for all children</li>
          <li>✓ Sibling adventure stories</li>
          <li>✓ All 12 mythologies</li>
          <li>✓ 40+ languages</li>
          <li>✓ Audio narration coming soon</li>
        </ul>
        <a href="/create" data-testid="pricing-family-cta" className="mt-6 block">
          <Button className="w-full h-11 bg-tl-purple hover:bg-tl-purpleDark text-white flex items-center justify-center gap-2">
            <Sparkles className="h-4 w-4" /> Start family plan
          </Button>
        </a>
      </div>
    </div>
  );
};
